import { Role } from '@dc-shared-web/hooks/api/user/constants'
import { useAuth } from '@dc-shared-web/providers/AuthProvider'

export const useIsProjectEditor = () => {
  const { user } = useAuth()
  return user.roles.some(
    (roleInfo) =>
      roleInfo.team_uuid === user._currOfficeUUID &&
      roleInfo.role === Role.EDITOR
  )
}
